/**
 * Turns any link pointing at "#woobox" into a Woobox quiz popup trigger.
 *
 * Editors set an ACF link field or a nav menu Custom Link URL to "#woobox";
 * this decorates those anchors with Woobox's data attributes, then loads
 * Woobox's embed.js — only on pages that actually have a trigger, and only
 * after the attributes are in place, since embed.js scans for [data-woobox]
 * when it loads.
 */
const HREF = '#woobox';
const CAMPAIGN = 'bdztmc';
const MAX_WIDTH = '640';
const SCRIPT_SRC = 'https://assets.woobox.com/embed.js';

class Woobox {
  constructor() {
    this.NAME = 'Woobox';
    this.triggers = document.querySelectorAll(`a[href="${HREF}"], a[href$="/${HREF}"]`);
  }

  init() {
    if (!this.triggers.length) return;

    this.triggers.forEach((link) => {
      link.setAttribute('data-woobox', CAMPAIGN);
      link.setAttribute('data-woobox-mode', 'popup');
      link.setAttribute('data-woobox-trigger', 'click');
      link.setAttribute('data-woobox-max-width', MAX_WIDTH);
      link.setAttribute('role', 'button');
      // Stops the "#woobox" hash being added to the URL (and any jump to
      // the top of the page) — Woobox opens the popup on its own listener.
      link.addEventListener('click', (e) => e.preventDefault());
    });

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }
}

export default Woobox;
